<template>
  <div>
    <el-table :data="paginatedData" v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </el-table>
    <kl-pagination :total="data.length" :page-size="pageSize" :current-page.sync="currentPage"
      @current-change="handlePageChange" @size-change="handleSizeChange" />
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    // 原始数据数组
    data: {
      type: Array,
      default: () => []
    },
    // 每页显示条目数
    pageSize: {
      type: Number,
      default: 10
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      myPageSize: this.pageSize
    }
  },
  computed: {
    // 计算分页后的数据
    paginatedData() {
      const start = (this.currentPage - 1) * this.myPageSize;
      const end = start + this.myPageSize;
      return this.data.slice(start, end);
    }
  },
  methods: {
    // 处理页码变更
    handlePageChange(page) {
      this.$emit('update:currentPage', page);
      this.$emit('page-change', page);
    },
    // 处理每页显示条目数变更
    handleSizeChange(size) {
      this.myPageSize = size;

      this.$emit('update:pageSize', size);
      this.$emit('size-change', size);
    }
  }
};
</script>